import { render, staticRenderFns } from "./country-deposit.vue?vue&type=template&id=1451cfe5&scoped=true"
import script from "./country-deposit.vue?vue&type=script&lang=js"
export * from "./country-deposit.vue?vue&type=script&lang=js"
import style0 from "./country-deposit.vue?vue&type=style&index=0&id=1451cfe5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1451cfe5",
  null
  
)

export default component.exports